import { MDBAlert, MDBBtn, MDBDataTable, MDBIcon } from "mdbreact"
import React from "react"
import Select from 'react-select'
import { Link } from "react-router-dom"
import { Card, CardBody, Col, Collapse, Container, Form, Input, Modal, ModalBody, ModalFooter, ModalHeader, Label, Media, Row } from "reactstrap"
import toastr from "toastr"
import ApiRest from "../../ayudas/apiRest"
import Breadcrumbs from '../../components/Common/Breadcrumb'
import _valid from "../../validations"

const columns = [
    {
        label: "Código",
        field: "articulo_codigo",
        sort: "asc",
    },
    {
        label: "Nombre",
        field: "articulo_nombre",
        sort: "asc",
        width: 150,
    },
    {
        label: "Serie",
        field: "articulo_serie",
        sort: "asc",
        width: 150,
    },
    {
        label: "Descripcion",
        field: "articulo_descripcion",
        sort: "asc",
        width: 150,
    },
    {
        label: "Costo",
        field: "articulo_costo",
        sort: "asc",
        width: 150,
    },
    {
        label: "Cantidad",
        field: "cantidad",
        sort: "asc",
        width: 150,
    },
    {
        label: "Monto Total",
        field: "monto_total",
        sort: "asc",
        width: 150,
    },
    {
        label: "Ubicación Activo",
        field: "area_trabajo_nombre",
        sort: "asc",
        width: 150,
    },
    {
        label: "Estado",
        field: "estado",
        sort: "asc",
        width: 150,
    }
];

export default class TajetaResponsabilidadAceptar extends React.Component {
    
    constructor(props) {
        super(props);

        this.apiRest = new ApiRest(props);
        this.colaborador = this.apiRest.ls.get('du').colaborador

        if (this.props.location.search.indexOf("=") > 0) {
            this.token = this.props.location.search.substring(this.props.location.search.indexOf("=") + 1, this.props.location.search.length);
        }

        this.state = {
            tabla: { columns: columns, rows: [] },
            colaborador: {},
            colapsar: true
        };
    }

    componentDidMount() {
        this.cargarListado();
    }

    colapsar() {
        this.setState(estadoAnterior => ({ colapsar: !estadoAnterior.colapsar }));
    }

    cargarListado = () => {
        this.setState( { mostrarSpinner: true });
        let url = '/tarjetaResponsabilidadArticulosUsuario/5';
        if (this.token !== undefined && this.token !== null) {
            url = '/tarjetaResponsabilidadArticulosToken/' + this.token;
        }

        this.apiRest.get(url).then(respuesta => {
            if (respuesta.exitoso) {
                this.setState({  mostrarSpinner: false, colaborador: respuesta.data.colaborador, tabla: { columns, rows: respuesta.data.articulos } });
            }
        });
    }

    aceptarRechazarAticulos = aceptarRechazar => {
        this.apiRest.post('/tarjetaResponsabilidadARArticulos', { aceptar: aceptarRechazar }).then(resultado => {
            if (resultado.exitoso) {
                toastr.success('Articulos ' + (aceptarRechazar ? 'aceptados' : 'rechazados') + ' exitosamente!');
                this.cargarListado();
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }
        });
    }

    render() {
        const { colapsar } = this.state;
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <Breadcrumbs title="Activos" breadcrumbItem="Tarjeta de Responsabilidad" />
                        <Row>
                            <Col className="col-12">
                                <Card>
                                    <CardBody>
                                        <Link onClick={() => this.colapsar()} className="text-dark" to="#">
                                            <div className="p-4">
                                                <Media className="d-flex align-items-center">
                                                    <div className="me-3">
                                                        <i className="uil uil-receipt text-primary h2"></i>
                                                    </div>
                                                    <div className="flex-1 overflow-hidden">
                                                        <h5 className="font-size-16 mb-1">Tarjeta de Responsabilidad</h5>
                                                        <p className="text-muted text-truncate mb-0">{this.state.colaborador.label}</p>
                                                        <p className="text-muted text-truncate mb-0">{this.state.colaborador.departamento_area}</p>
                                                    </div>
                                                    <i className="mdi mdi-chevron-up accor-down-icon font-size-24"></i>
                                                </Media>
                                            </div>
                                        </Link>
                                        <Collapse isOpen={colapsar}>
                                            <div className="p-4 border-top">
                                                <Form>
                                                    <Row>
                                                        <Col lg={12}>                                                            
                                                            <div className="table-responsive">
                                                                <MDBDataTable hover searchLabel="Buscar.." paginationLabel={["Anterior", "Siguiente"]} noRecordsFoundLabel="No hay datos." infoLabel={["Mostrando desde ", "hasta", " | Entradas totales: ", ""]} entriesLabel="Mostrando entradas" data={this.state.tabla} />
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </Form>
                                            </div>

                                            <Row>
                                                <Col lg={12} className="text-end">
                                                    <MDBBtn className="waves-effect"color="warning" onClick={() => this.aceptarRechazarAticulos(false)}>
                                                        <MDBIcon icon="fa fa-thumbs-down" />{' '}
                                                        Rechazar
                                                    </MDBBtn>
                                                    {' '}
                                                    <MDBBtn className="waves-effect"color="success" onClick={() => this.aceptarRechazarAticulos(true)}>
                                                        <MDBIcon icon="fa fa-thumbs-up" /> {' '}
                                                        Aceptar
                                                    </MDBBtn>
                                                </Col>
                                            </Row>
                                        </Collapse>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        );
    }
}